import { Fragment, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import { setAlert } from '../../../actions/alert';
import {
    buscarUnidades,
    obtenerUnidadesProducto,
    editarUnidadesProducto
} from '../../../actions/configuracion';

import { CustomValueContainer } from '../../../components/react_select/ReactSelect';

const styles_select = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    container: (provided) => ({ ...provided }),
    valueContainer: (provided) => ({
        ...provided,
        overflow: 'visible',
        marginTop: '10px'
    }),
    placeholder: (provided, state) => ({
        ...provided,
        position: 'absolute',
        top: state.hasValue || state.selectProps.inputValue ? -15 : '0%',
        transition: 'top 0.1s, font-size 0.1s',
        fontSize: (state.hasValue || state.selectProps.inputValue) && 13
    })
};

const tiposFilter = [
    { value: 1, label: 'Inventario' },
    { value: 3, label: 'Venta' }
];

const EditarUnidadesModal = ({ show, onHide, productoId, productoNombre, onUnidadesActualizadas }) => {
    const dispatch = useDispatch();

    const { listado: listado_unidades } = useSelector((state) => state.configuracion.unidades);

    const [statusProcesar, setStatusProcesar] = useState(false);

    const [unidades, setUnidades] = useState([]);
    const [tiposData, setTiposData] = useState([]);
    const [unidadesData, setUnidadesData] = useState([]);
    const [unidadesFilter, setUnidadesFilter] = useState([]);

    useEffect(() => {
        const options = (listado_unidades || []).map((u) => ({
            value: u._id,
            label: u.nombre
        }));
        setUnidadesFilter(options);
    }, [listado_unidades]);

    const handleAbrir = async () => {
        dispatch(buscarUnidades());

        if (!productoId) return;

        const arr = await dispatch(obtenerUnidadesProducto(productoId));
        const safeArr = Array.isArray(arr) ? arr : [];

        setUnidades(
            safeArr.map((u) => ({
                id_unidad: u?.unidad?._id || '',
                tipo: u?.tipo !== null && u?.tipo !== undefined ? u.tipo : '',
                cantidad: String(u?.cantidad || '')
            }))
        );

        setTiposData(
            safeArr.map((u) => tiposFilter.find((t) => t.value === u?.tipo) || null)
        );

        setUnidadesData(
            safeArr.map((u) => {
                const id = u?.unidad?._id || '';
                const nombre = u?.unidad?.nombre || '';
                return id ? { value: id, label: nombre } : null;
            })
        );
    };

    const handleAgregarUnidad = () => {
        setUnidades((prev) => [...prev, { id_unidad: '', tipo: '', cantidad: '' }]);
        setTiposData((prev) => [...prev, null]);
        setUnidadesData((prev) => [...prev, null]);
    };

    const handleCantidadChange = ({ target }) => {
        const partes = target.name.split('cantidad_');
        const idx = Number(partes[1]);

        setUnidades((prev) => {
            const copy = [...prev];
            if (!copy[idx]) return prev;
            copy[idx] = { ...copy[idx], cantidad: target.value || '' };
            return copy;
        });
    };

    const handleSelectTipo = (option, idx) => {
        setTiposData((prev) => {
            const copy = [...prev];
            copy[idx] = option;
            return copy;
        });

        setUnidades((prev) => {
            const copy = [...prev];
            if (!copy[idx]) return prev;
            copy[idx] = { ...copy[idx], tipo: option ? option.value : '' };
            return copy;
        });
    };

    const handleSelectUnidad = (option, idx) => {
        setUnidadesData((prev) => {
            const copy = [...prev];
            copy[idx] = option;
            return copy;
        });

        setUnidades((prev) => {
            const copy = [...prev];
            if (!copy[idx]) return prev;
            copy[idx] = { ...copy[idx], id_unidad: option ? option.value : '' };
            return copy;
        });
    };

    const handleEliminarUnidad = ({ currentTarget }) => {
        const partes = (currentTarget.id || '').split('_');
        const idx = Number(partes[1]);
        if (Number.isNaN(idx)) return;

        setUnidades((prev) => prev.filter((_, i) => i !== idx));
        setTiposData((prev) => prev.filter((_, i) => i !== idx));
        setUnidadesData((prev) => prev.filter((_, i) => i !== idx));
    };

    const handleFilasUnidades = () => {
        return unidades.map((u, x) => (
            <div className="col-md-12 form-group mb-3" key={'unidad-row-' + x}>
                <div className="input-group h-100">
                    <div className="form-floating h-100">
                        <Select
                            name="tipo"
                            className="select-group"
                            classNamePrefix="react-select"
                            placeholder={'Tipo de unidad ' + (x + 1)}
                            options={tiposFilter}
                            value={tiposData[x] || null}
                            isClearable
                            onChange={(value) => handleSelectTipo(value, x)}
                            menuPortalTarget={document.body}
                            menuPlacement="auto"
                            components={{ ValueContainer: CustomValueContainer }}
                            styles={{ ...styles_select }}
                        />
                    </div>

                    <div className="form-floating h-100">
                        <Select
                            name="unidad"
                            className="select-group"
                            classNamePrefix="react-select"
                            placeholder={'Unidad ' + (x + 1)}
                            options={unidadesFilter}
                            value={unidadesData[x] || null}
                            isClearable
                            onChange={(value) => handleSelectUnidad(value, x)}
                            menuPortalTarget={document.body}
                            menuPlacement="auto"
                            components={{ ValueContainer: CustomValueContainer }}
                            styles={{ ...styles_select }}
                        />
                    </div>

                    <div className="form-floating">
                        <input
                            type="number"
                            className="form-control"
                            placeholder="Cantidad"
                            id={'cantidad_' + x}
                            name={'cantidad_' + x}
                            value={u.cantidad || ''}
                            onChange={handleCantidadChange}
                        />
                        <label htmlFor={'cantidad_' + x}>Cantidad {x + 1}</label>
                    </div>

                    <div className="input-group-append">
                        <button
                            type="button"
                            className="btn btn-danger delete"
                            id={'eliminarUnidad_' + x}
                            onClick={handleEliminarUnidad}
                        >
                            <i className="fa-solid fa-xmark"></i>
                        </button>
                    </div>
                </div>
            </div>
        ));
    };

    const handleGuardar = async () => {
        const raw = unidades;

        const mapped = raw
            .map((u) => ({
                id_unidad: u?.id_unidad ? String(u.id_unidad) : '',
                tipo: u?.tipo !== null && u?.tipo !== undefined && u?.tipo !== '' ? String(u.tipo) : '',
                cantidad: u?.cantidad !== null && u?.cantidad !== undefined && u?.cantidad !== '' ? String(u.cantidad) : ''
            }))
            .filter((u) => u.id_unidad && u.tipo !== '' && u.cantidad !== '');

        if (raw.length && mapped.length !== raw.length) {
            dispatch(setAlert('Completa tipo, unidad y cantidad en todas las unidades o elimínalas.', 'warning'));
            return;
        }

        setStatusProcesar(true);
        const ok = await dispatch(editarUnidadesProducto(productoId, mapped));
        setStatusProcesar(false);

        if (!ok) return;

        const unidadesActualizadas = raw
            .map((u, i) => ({
                unidad: {
                    _id: u.id_unidad,
                    nombre: unidadesData[i]?.label || ''
                },
                tipo: Number(u.tipo),
                cantidad: Number(u.cantidad)
            }))
            .filter((u) => u.unidad._id);

        if (onUnidadesActualizadas) {
            onUnidadesActualizadas(unidadesActualizadas);
        }

        handleCerrar();
    };

    const handleCerrar = () => {
        if (statusProcesar) return;

        setUnidades([]);
        setTiposData([]);
        setUnidadesData([]);

        if (onHide) onHide();
    };

    return (
        <Fragment>
            <HelmetProvider>
                <Helmet>
                    <style>{`
                        .select-group { height: 100%; }
                        .delete {
                            padding: 0.39rem 0.70rem !important;
                            border-radius: 0 25% 25% 0 !important;
                            height: 100%;
                        }
                        .btn-morado {
                            background: #6f42c1 !important;
                            border-color: #6f42c1 !important;
                            color: #fff !important;
                        }
                        .btn-morado:hover { filter: brightness(0.95); }
                    `}</style>
                </Helmet>
            </HelmetProvider>

            <Modal
                show={show}
                size="xl"
                backdrop="static"
                centered
                onEntered={handleAbrir}
                onHide={handleCerrar}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Editar unidades{productoNombre ? ` — ${productoNombre}` : ''}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="row">
                        {unidades.length === 0 && (
                            <div className="col-12 text-muted mb-2">
                                Sin unidades registradas. Agrega al menos una.
                            </div>
                        )}

                        {handleFilasUnidades()}
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    {statusProcesar ? (
                        <>
                            <button type="button" className="btn btn-morado" disabled>
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Unidad
                            </button>
                            <button type="button" className="btn btn-success" disabled>
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Guardar
                            </button>
                        </>
                    ) : (
                        <>
                            <button
                                type="button"
                                className="btn btn-morado"
                                onClick={handleAgregarUnidad}
                            >
                                <i className="fas fa-plus fa-sm"></i> Unidad
                            </button>

                            <button
                                type="button"
                                className="btn btn-success"
                                onClick={handleGuardar}
                            >
                                <i className="fas fa-check fa-sm"></i> Guardar
                            </button>
                        </>
                    )}
                </Modal.Footer>
            </Modal>
        </Fragment>
    );
};

export default EditarUnidadesModal;
